export default __webpack_public_path__ + "static/media/img-new-home-2-mobile.b18abb61.png";